/**
 * Bouwt een prefilled mailto: URL voor LevelLeven.
 */
export function buildPilotMailto({ subject, body } = {}) {
  const to = "info@levelleven.nl";
  const s = subject || "Pilotgesprek LevelLeven";
  const b =
    body ||
    `Beste LevelLeven,

Wij zijn geïnteresseerd in een pilot binnen onze gemeente.

Gemeente:
Contactpersoon:
Functie:
Telefoon:

Met vriendelijke groet,`;
  return `mailto:${to}?subject=${encodeURIComponent(s)}&body=${encodeURIComponent(b)}`;
}

export function buildDeelnemerMailto() {
  return `mailto:info@levelleven.nl?subject=${encodeURIComponent(
    "Aanmelden LevelLeven"
  )}&body=${encodeURIComponent(
    `Hoi LevelLeven,

Ik wil graag meer weten over deelnemen aan het programma.

Naam:
Woonplaats:
Telefoon (optioneel):

Groet,`
  )}`;
}

export function buildRoiScenarioMailto({ deelnemers, uitstroom }) {
  return `mailto:info@levelleven.nl?subject=${encodeURIComponent(
    "ROI-scenario LevelLeven"
  )}&body=${encodeURIComponent(
    `Beste LevelLeven,

Wij hebben op de website onderstaand scenario doorgerekend en willen dit graag met u bespreken.

- Aantal deelnemers: ${deelnemers}
- Verwachte uitstroom: ${uitstroom}%
- Direct-linkbaar scenario: ${window.location.origin}/gemeenten?d=${deelnemers}&u=${uitstroom}

Gemeente:
Contactpersoon:
Functie:
Telefoon:

Met vriendelijke groet,`
  )}`;
}

export const ASSET_BROCHURE_URL = "/downloads/Levelleven-brochure-v16.pdf";
export const ASSET_VIGOR_URL = "/downloads/Levelleven-VIGOR-brochure.pdf";
export const ASSET_FLYER_URL = "/downloads/Levelleven-flyer.png";
export const ASSET_FLYER_IMG = "/downloads/Levelleven-flyer.jpg";
export const ASSET_QA_URL =
  "https://levelleven.sales-surge.io/__l5e/assets-v1/70d26cb0-f7ca-4e66-9c46-e4477dba4bb6/Levelleven-veelgestelde-vragen.pdf";
